import { ThemeIcon, useMantineTheme } from '@mantine/core';
import { IconPlus } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useModalState } from '../Molecules/Dialogs';
import { UpgradeModal } from '../Organismns/Upgrade/UpgradeModal';
import { AuthContext, Licence } from '../Service/Context/AuthContext';
import { hasSuitableLicence } from '../Service/helper/LicenceService';

const BookitupAddIcon: FC<{
  onClick?: () => void;
  requiredLicence?: Licence;
  upgradeTitle?: string;
  upgradeText?: string;
  id?: string;
  testId?: string;
  disabled?: boolean;
}> = ({ onClick, requiredLicence, upgradeTitle, upgradeText, id, testId, disabled = false }) => {
  const { jwtClaims } = useContext(AuthContext);
  const { show, toggle } = useModalState(false);
  const { licence } = jwtClaims;
  const valid = requiredLicence && licence ? hasSuitableLicence(requiredLicence, licence) : true;

  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  return (
    <ThemeIcon
      id={id}
      size={20}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      variant="gradient"
      gradient={
        disabled
          ? { from: '#B7B7B7', to: '#D4D4D4', deg: 135 }
          : darkMode
          ? { from: colors.blue[1], to: colors.blue[4], deg: 135 }
          : { from: colors.blue[4], to: colors.blue[0], deg: 135 }
      }
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          return;
        }
        if (valid) {
          onClick?.();
        } else {
          toggle();
        }
      }}
    >
      <IconPlus data-testid={testId} color="white" />
      <UpgradeModal show={show} toggle={toggle} title={upgradeTitle} text={upgradeText} licence={requiredLicence} />
    </ThemeIcon>
  );
};

export default BookitupAddIcon;
